<template>
  <div class="game-start-container">

    <!-- GAME FRAME -->
    <div class="iframe-wrapper">

    <div v-if="isLoading" class="app-loader">
  <div class="loader-container">
    <div class="container-inner">
      <img src="@/assets/img/logomini.png" />
    </div>
  </div>
</div>


      <iframe
        v-if="gameUrl"
        :src="gameUrl"
        class="game-iframe"
        frameborder="0"
        allowfullscreen
        @load="handleIframeLoad"
      ></iframe>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "GameStart",

  data() {
    return {
      gameUrl: "",
      gameDetails: {},
      isLoading: true,
      iframeLoadTimeout: null,
    };
  },

  computed: {
    ...mapGetters(["authUser"]),
  },

  async mounted() {
    await this.loadGameData();
  },

  methods: {
    ...mapActions(["addNotification"]),

    notify(message, type = "error") {
      this.addNotification({
        id: Date.now(),
        type,
        message,
      });
    },

async loadGameData() {
  try {
    const gameId = this.$route.params.id;
    const gameResponse = await axios.get(`/games/${gameId}`);
    this.gameDetails = gameResponse.data.data;

    // 🔥 BURAYA EKLE
    console.log("DIST RAW:", this.gameDetails.distribution);
    console.log(
      "DIST CHECK:",
      JSON.stringify(this.gameDetails.distribution),
      this.gameDetails.distribution === "nexus"
    );

    if (this.gameDetails.distribution === "oroplay") {
      await this.launchOroPlayGame();
    }

    if (this.gameDetails.distribution === "drakon") {
      await this.launchDrakonGame();
    }

    if (this.gameDetails.distribution === "nexus") {
      await this.launchNexusGame();
    }
  } catch (err) {
    this.notify("Oyun bilgisi alınamadı: " + err.message);
  }
},



    // -----------------------
    // OROPLAY LAUNCH
    // -----------------------
   async launchOroPlayGame() {
  try {
    const lang = this.$i18n?.locale || 'en';

    const res = await axios.post("/oroplay/game/launch", {
      userId: this.authUser?.user?._id,
      vendorCode: this.gameDetails.provider_code,
      gameCode: this.gameDetails.game_code,
      language: lang, // ✅ i18n
      lobbyUrl: window.location.origin,
    });

    if (res.data?.success && res.data?.launchUrl) {
      this.gameUrl = res.data.launchUrl;
      this.iframeLoadTimeout = setTimeout(() => {
        this.isLoading = false;
      }, 6000);
    } else {
      this.notify("OroPlay oyun başlatılamadı");
    }
  } catch (err) {
    this.notify("OroPlay başlatma hatası: " + err.message);
  }
},


   async launchDrakonGame() {
  try {
    const lang = this.$i18n?.locale || 'en';

    const res = await axios.post("/drakon_api", {
      method: "game_launch",
      user_id: this.authUser?.user?.phone,
      game_id: this.gameDetails.game_code,
      lang, // ✅ i18n
      currency: this.authUser?.user?.currency?.fiatCurrency || "USD",
      type: "CHARGED",
    });

    if (res.data?.status && res.data?.game_url) {
      this.gameUrl = res.data.game_url;
      this.iframeLoadTimeout = setTimeout(() => {
        this.isLoading = false;
      }, 6000);
    } else {
      this.notify("Drakon oyun başlatılamadı");
    }
  } catch (err) {
    this.notify("Drakon launch hatası: " + err.message);
  }
},


async launchNexusGame() {
  try {
    const lang = this.$i18n?.locale || "en";

    const res = await axios.post("/gold_api", {
      method: "game_launch",
      user_code: this.authUser?.user?._id,
      provider_code: this.gameDetails.provider_code,
      game_code: this.gameDetails.game_code,
      lang // ✅ i18n
    });

    /**
     * Nexus response örnek:
     * {
     *   status: 1,
     *   game_url: "https://..."
     * }
     */

    if (res.data?.status === 1 && res.data?.game_url) {
      this.gameUrl = res.data.game_url;

      this.iframeLoadTimeout = setTimeout(() => {
        this.isLoading = false;
      }, 6000);
    } else {
      this.notify("Nexus oyun başlatılamadı");
    }
  } catch (err) {
    this.notify("Nexus launch hatası: " + err.message);
  }
},




    // -----------------------
    // IFRAME LOAD HANDLER
    // -----------------------
    handleIframeLoad() {
      this.isLoading = false;
      clearTimeout(this.iframeLoadTimeout);
    },
  },
};
</script>


<style>
.game-start-container {
  padding: 0;
  margin: 0;
  margin-top: 10px;
}

/* === IFRAME AREA === */
.iframe-wrapper {
  position: relative;
  width: 100%;
  height: 75vh;
  background: #000;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0,0,0,0.5);
}

/* === NEW PREMIUM LOADER === */
.loader-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .85);
  backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  animation: fadeIn .3s ease-out;
}

.loader-spinner {
  width: 70px;
  height: 70px;
  border: 4px solid #3c2ea7;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

.loader-text {
  margin-top: 18px;
  color: #dcdcff;
  font-size: 18px;
  opacity: 0.9;
  letter-spacing: 1px;
}

/* === IFRAME === */
.game-iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

/* === ANIMATIONS === */
@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
  .app-loader {
  position: absolute;   /* 🔥 FIX */
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--background);
  z-index: 10;
}


    .app-loader .loader-container {
        width: 160px;
        height: 160px;
        position: relative;
        padding: 2px;
        border-radius: 50%;
        overflow: hidden;
        top: -10%;
    }

    .app-loader .loader-container::before {
        content: '';
        width: 160px;
        height: 160px;
        position: absolute;
        top: 50%;
        left: 50%;
        background: linear-gradient(90deg, rgba(0, 0, 0, 0.2) 25%, #01ebae 100%);
        z-index: -1;
        animation: rotateAnimation 2s linear infinite;
    }

    .app-loader .container-inner {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: var(--background1);
        overflow: hidden;
    }

 

    @keyframes rotateAnimation {
        0% {
            transform: translate(-50%, -50%) rotate(0deg);
        }
        100% {
            transform: translate(-50%, -50%) rotate(360deg);
        }
    }
</style>